import { CompanyIndustry } from '../../../types/company.types';

export type PerkClaim =
  | {
      claimCode: string;
      claimDisplayRule: PerkClaimDisplayRule;
      claimType: PerkClaimType.PROMO_CODE;
    }
  | {
      claimType: PerkClaimType.LINK;
      claimUrl: string;
    };

type PerkBase = {
  active: boolean;
  banner: string;
  claimType: PerkClaimType;
  claimUrl: string;
  clicksCount: number;
  contactPerson: string;
  createdAt: Date;
  draft: boolean;
  id: string;
  industry: CompanyIndustry;
  logo: string;
  offerDescription: string;
  offerTypes: PerkOfferType[];
  partnerDescription: string;
  partnerName: string;
  partnerShortDescription: string;
  partnerSlogan: string;
  regionsApplicable: string[];
  updatedAt: Date;
  url: string;
} & PerkClaim;

export type PerkDraft = {
  clicksCount: number;
  createdAt: Date;
  draft: true;
  id: string;
  updatedAt: Date;
} & Nullable<PerkBase>;

type PerkPublished = {
  draft: false;
} & PerkBase;

export type Perk = PerkDraft | PerkPublished;

export enum RegionType {
  COUNTRY = 'region-type:country',
  GROUP = 'region-type:group',
}

export enum PerkClaimType {
  LINK = 'perk-claim-type:link',
  PROMO_CODE = 'perk-claim-type:promo-code',
}

export enum PerkClaimDisplayRule {
  ON_CLICK = 'perk-claim-display-rule:on-click',
  VIA_EMAIL = 'perk-claim-display-rule:via-email',
}

export enum PerkOfferType {
  EXCLUSIVE = 'perk-offer-type:exclusive',
  LIMITED = 'perk-offer-type:limited',
}
export const itemsToFetchMap = [5, 10, 20, 50, 100];

export const perkClaimDisplayRuleTranslationKey: Record<PerkClaimDisplayRule, string> = {
  [PerkClaimDisplayRule.ON_CLICK]: 'Display code on click',
  [PerkClaimDisplayRule.VIA_EMAIL]: 'Send code via email',
};

export const perkClaimDisplayRuleMap = Object.keys(perkClaimDisplayRuleTranslationKey);

export const perkClaimTypeTranslationKey: Record<PerkClaimType, string> = {
  [PerkClaimType.PROMO_CODE]: 'Promocode',
  [PerkClaimType.LINK]: 'Link to website',
};

export const perkClaimTypeMap = Object.keys(perkClaimTypeTranslationKey);

export const perkOfferTranslationKey: Record<PerkOfferType, string> = {
  [PerkOfferType.EXCLUSIVE]: 'Exclusive',
  [PerkOfferType.LIMITED]: 'Limited',
};

export const perkOfferTypeOrderMap = Object.keys(perkOfferTranslationKey);

export const perkClaimTypeOrderMap = Object.keys(perkClaimTypeTranslationKey);
